// Module
var code = "<p translate-once=\"careers.edit_career_profile.answers_too_short_modal.description\"></p><div class=\"center\"><button class=\"flat blue\" ng-click=\"closeModal()\" translate-once=\"careers.edit_career_profile.answers_too_short_modal.close\"></button></div>";
// Exports
export default code;